// extracted by mini-css-extract-plugin
export default {"fv":"U06S9MApN-fjFnfYgtUy-w==","image":"+EaARJ71t9exlCkeZYW3fw==","placeholder":"_6UoxaErl6x+ejFqCecBQ2A=="};